import { Analytics } from '@aws-amplify/analytics';
import { Auth } from '@aws-amplify/auth';
import verFlavor from "@/appFlavorAndVersion";
import { getCognitoAuthConfigForAmplify, getPinPointConfig } from "@/flavors";
import { getHeaders } from './authService';
import store from "../store";
import moment from "moment-timezone";


export const AnalyticsEvents = {
  v2AppLoaded: 'v2AppLoaded', //done
  //RollNumbersignin
  v2SignInPageOpen: 'v2SignInPageOpen', //done
  v2SignInAttempt: 'v2SignInAttempt', //done
  v2SignInSuccess: 'v2SignInSuccess', //done
  v2SignInFailure: 'v2SignInFailure', //done

  //PhoneSignIn
  v2SignInPhoneNumberPageOpen: 'v2SignInPhoneNumberPageOpen',
  v2SignInPhoneNumberAttemptGenerateOTP_step1: 'v2SignInPhoneNumberAttemptGenerateOTP_step1',
  v2SignInPhoneNumberAttemptValidateOTP_step2: 'v2SignInPhoneNumberAttemptValidateOTP_step2',
  v2SignInPhoneNumberAttemptEnterUserInfo_step3: 'v2SignInPhoneNumberAttemptEnterUserInfo_step3',
  v2SignInPhoneNumberResendOTP: 'v2SignInPhoneNumberResendOTP',
  v2SignInPhoneNumberSuccess: 'v2SignInPhoneNumberSuccess',
  v2SignInPhoneNumberFailure: 'v2SignInPhoneNumberFailure',

  //signout
  v2SignoutUserSession: 'v2SignoutUserSession', //done
  v2Signout: 'v2Signout', //done

  //refundpolicy
  v2RefundPolicyPageOpen: 'v2RefundPolicyPageOpen',
  v2RefundPolicyAccepted: 'v2RefundPolicyAccepted',
  v2RefundPolicyDeclined: 'v2RefundPolicyDeclined',
  v2RefundPolicyDocumentOpen: 'v2RefundPolicyDocumentOpen',
  //Domain
  v2DomainChanged: 'v2DomainChanged', //done
  //Profile
  v2ViewProfile: 'v2ViewProfile',
  //Learn
  v2LearnOpen: 'v2LearnOpen', //done
  v2LearnSearch: 'v2LearnSearch', //done //searchtext
  v2LearnNodeDrilldown: 'v2LearnNodeDrilldown', //done // nodeid and nodename
  v2LearnPlayVideo: 'v2LearnPlayVideo', //done // videoname videoid
  v2LearnOpenPdf: 'v2LearnOpenPdf', //done //pdfname pdfid
  v2LearnDownloadPdf: 'v2LearnDownloadPdf', //done //pdfname pdfid
  v2LearnopenLink: 'v2LearnOpenLink', //done //linkurl
  //MyClasses
  v2MyClassesPageOpen: 'v2MyClassesPageOpen', //done
  v2MyClassesSearch: 'v2MyClassesSearch', //done //searchtext
  v2MyClassesJoinZoomMeeting: 'v2MyClassesJoinZoomMeeting', //done //meetingid
  //MyNotifications
  v2MyNotifPageOpen: 'v2MyNotifPageOpen', //done
  v2MyNotifSearch: 'v2MyNotifSearch', //searchtext
  v2MyNotifViewDetails: 'v2MyNotifViewDetails', //done //notificationid
  v2MyNotifMarkAsStarred: 'v2MyNotifMarkAsStarred', //done //noptificationid
  v2MyNotifUnMarkAsStarred: 'v2MyNotifUnMarkAsStarred',//done //noptificationid
  v2MyNotifMarkAsRead: 'v2MyNotifMarkAsRead', //done //noptificationid
  v2MyNotifMarkAsUnRead: 'v2MyNotifMarkAsUnRead',//done //noptificationid
  //Tests
  v2TestSeriesPageOpen: 'v2TestSeriesPageOpen',
  v2TestSeriesNodeOpen: 'v2TestSeriesNodeOpen', // testseriescollectionid, testseriesname
  v2TestStatusGroupOpen: 'v2TestStatusGroupOpen', // testseriescollectionid, testseriesname, testseriesgroupname (active, attempted, upcoming, missed)
  v2TestListTestDetailOpen: 'v2TestListTestDetailOpen', // testId, testName
  v2TestListStartTest: 'v2TestListStartTest', // testId, testName
  v2TestListResumeTest: 'v2TestListResumeTest', // testId, testName
  v2TestListStartPracticeTest: 'v2TestListStartPracticeTest', // testId, testName

  v2TestBeginTest: 'v2TestBeginTest', // testId, testName
  v2TestInteractionWithQuestionOptions: 'v2TestInteractionWithQuestionOptions',
  v2TestQuestionMarkedForReview: 'v2TestQuestionMarkedForReview',
  v2TestSubmitButtonClickedDuringTest: 'v2TestSubmitButtonClickedDuringTest',
  v2TestNextButtonClicked: 'v2TestNextButtonClicked',
  v2TestPreviousButtonPressed: 'v2TestPreviousButtonPressed',
  v2TestQuestionJumpedFromQuestionListPopup: 'v2TestQuestionJumpedFromQuestionListPopup',
  v2TestClearResponseButtonPressed: 'v2TestClearResponseButtonPressed',
  v2TestResumeTest: 'v2TestResumeTest', // testId, testName
  v2TestBeginPracticeTest: 'v2TestBeginPracticeTest', // testId, testName
  v2TestExitTestFromStartTestScreen: 'v2TestExitTestFromStartTestScreen', // testId, testName
  v2TestQuestionResponseSentToServer: 'v2TestQuestionResponseSentToServer',
  v2TestExitInProgressTest: 'v2TestExitInProgressTest', // testId, testName
  v2TestSubmitTest: 'v2TestSubmitTest', // testId, testName
  v2TestAutoSubmitTest: 'v2TestAutoSubmitTest',
  v2TestSectionInstructionsDuringTest: 'v2TestSectionInstructionsDuringTest',// testId, testName
  v2TestInstructionsDuringTest: 'v2TestInstructionsDuringTest', // testId, testName
  v2TestBackFromReviewPageClicked: 'v2TestBackFromReviewPageClicked',
  v2TestQuestionListPopupOpen: 'v2TestQuestionListPopupOpen',

  v2TestListTestReportsOpen: 'v2TestListTestReportsOpen',
  v2TestInstanceViewSolutionsOpen: 'v2TestInstanceViewSolutionsOpen',
  v2TestClockDriftHappened: 'v2TestClockDriftHappened',
  v2TestUpdateSyncTimerCalledBetweenTest: 'v2TestUpdateSyncTimerCalledBetweenTest',

  //Combined Test analytics
  v2CombinedTestsReportPageOpened: 'v2CombinedTestsReportPageOpened',
  v2CombinedTestReportView: 'v2CombinedTestReportView',



  //LocalForage API fail analytics for test

  v2ErrorSetInLocalForageFailed: 'v2ErrorSetInLocalForageFailed',
  v2ErrorSetInLocalStorageFailed: 'v2ErrorSetInLocalStorageFailed',
  v2ErrorSetInMemoryStorageFailed: 'v2ErrorSetInMemoryStorageFailed',

  v2ErrorGetInLocalForageFailed: 'v2ErrorGetInLocalForageFailed',
  v2ErrorGetInLocalStorageFailed: 'v2ErrorGetInLocalStorageFailed',
  v2ErrorGetInMemoryStorageFailed: 'v2ErrorGetInMemoryStorageFailed',

  //Calendar Anylitics
  v2CalendarLoaded: 'v2CalendarLoaded',
  v2CalendarPrevPressed: 'v2CalendarPrevPressed',
  v2CalendarNextPressed: 'v2CalendarNextPressed',
  v2CalendarMonthViewShow: 'v2CalendarMonthViewShow',
  v2CalendarWeekViewShow: 'v2CalendarWeekViewShow',
  v2CalendarDayViewShow: 'v2CalendarDayViewShow',
  v2CalendarListViewShow: 'v2CalendarListViewShow',
  v2CalendarEventPressed: 'v2CalendarEventPressed',
  v2CalendarOnlineClassOpen: 'v2CalendarOnlineClassOpen',
  v2CalendarTestOpen: 'v2CalendarTestOpen',
  v2CalendarTodayButtonPressed: 'v2CalendarTodayButtonPressed',
  v2CalendarRefreshButtonPressed: 'v2CalendarRefreshButtonPressed',


  //Homework Anylitics
  v2HomeworkLoaded : 'v2HomeworkLoaded',
  v2HomeworkDetailsOpened: 'v2HomeworkDetailsOpened',
  v2HomeworkTabSwitched: 'v2HomeworkTabSwitched',
  v2HomeworkStartTaskClicked:'v2HomeworkStartTaskClicked',
  v2HomeworkReportOpen: 'v2HomeworkReportOpen',
  v2HomeworkPagination: 'v2HomeworkPagination',
  v2HomeworkSearchUsed: 'v2HomeworkSearchUsed',

  v2HomeworkSubjectiveBackPressed: 'v2HomeworkSubjectiveBackPressed',
  v2HomeworkSubjectiveSubmitSheetOpened: 'v2HomeworkSubmitSheetOpened',
  v2HomeworkSubjectiveSubmitSheetClosed: 'v2HomeworkSubjectiveSubmitSheetClosed',
  v2HomeworkSubjectiveSubmited: 'v2HomeworkSubjectiveSubmited',

  v2HomeworkSubjectiveTeacherDocumentOpen: 'v2HomeworkSubjectiveTeacherDocumentOpen',
  v2HomeworkSubjectiveStudentOwnUploadedDocumentOpen: 'v2HomeworkSubjectiveStudentOwnUploadedDocumentOpen',
  v2HomeworkSubjectiveReviewedDocumentOpen: 'v2HomeworkSubjectiveReviewedDocumentOpen',
  v2HomeworkSubjectiveModifyDocuemntButtonClicked: 'v2HomeworkSubjectiveModifyDocuemntButtonClicked',

  //Homework Test Results Anaylytics
  v2HomeworkResultPageLoadedWithoutTestId: 'v2HomeworkResultPageLoadedWithoutTestId',
  v2HomeworkResultPageLoaded: 'v2HomeworkResultPageLoaded',
  v2HomeworkTestReportsOpen: 'v2HomeworkTestReportsOpen',
  v2HomeworkTestReportBackButtonClicked: 'v2HomeworkTestReportBackButtonClicked',
  v2HomeworkTestReportViewSolutionClicked: 'v2HomeworkTestReportViewSolutionClicked',
  
  //TestErrorPinpointAnylitics
  v2TestUserAttemptMethodInStoreFailed: 'v2TestUserAttemptMethodInStoreFailed',
  v2TestUserAttemptMethodInTestQuestionPageFailed: 'v2TestUserAttemptMethodInTestQuestionPageFailed',
  v2TestRecordErrorAPIFailed: 'v2TestRecordErrorAPIFailed',
};

const amplifyConfig = {
  Auth: getCognitoAuthConfigForAmplify()
}

const analyticsConfig = {
  AWSPinpoint: getPinPointConfig()
}

export function initializeAWSPinpointAnalytics() {
  //Initialize Amplify
  Auth.configure(amplifyConfig);

  Analytics.configure(analyticsConfig);
  enableAutoSessionTracking();
  enableAutoPageViewTracking();
}

function enableAutoSessionTracking() {
  Analytics.autoTrack('session', {
    enable: true,
    attributes: () => {
      return getCommonAttributes();
    },
  });
}

function enableAutoPageViewTracking() {
  Analytics.autoTrack('pageView', {
    enable: true,
    attributes: () => {
      return getCommonAttributes();
    },
    type: 'SPA',
    // getUrl: () => {
    //   // the default function
    //   return window.location.href;
    // }
  });
}

export function recordAnalyticsEvent(eventName, eventAttributes) {

  //console.log("value of isUSerLogged In !!!!!!!" , JSON.parse(localStorage.getItem("isUserLoggedIn")));
  if(!store.state.isSSOLogin){
    store.dispatch("lastActivity", {buildmode : "web"})
  }

  if(!window.navigator.onLine){
    //console.log("are you online ? ", window.navigator.onLine);
    store.commit("setErrorSnackbar", true)
  }

  let commonAttributes = getCommonAttributes();

  let attributeValues = { ...eventAttributes, ...commonAttributes };
  
  
  Analytics.record({
    name: eventName,
    attributes: attributeValues,
  });

  //console.log(`Recording Analaytics Event: ${eventName} | ${JSON.stringify(attributeValues)}`);
}

function getCommonAttributes() {

  let attrs = new Object();
  attrs.appflavour = verFlavor.APP_FLAVOR;
  attrs.appversion = verFlavor.APP_VERSION;
  attrs.appbuildnumber = verFlavor.APP_BUILDNUMBER;
  attrs.appbuildmode = "web";
  attrs.eventtimestampms = Math.floor(Date.now());
  let headers = getHeaders();
  
  let userId = headers.userid;
  if (!userId) {
    userId = 'notloggedin'
  }
  attrs.deviceid = headers.deviceid;
  attrs.domainid = headers.domainid;
  attrs.organizationid = headers.organizationid;
  attrs.userid = userId;
  attrs.userAgent = navigator.userAgent;
  attrs.appRunnningOn = getDevice();
  attrs.browser = getBrowserName();
  attrs.platform = navigator.platform;
  attrs.browserappname = navigator.appName;
  attrs.browserappVersion = navigator.appVersion;
  attrs.browservendor = navigator.vendor;
  attrs.pageURL = window.location.href;
  attrs.origin = window.location.origin;
  attrs.devicescreenheight = window.screen.availHeight;
  attrs.devicescreenwidth = window.screen.availWidth;
  attrs.deviceabsoluteheight = window.screen.height;
  attrs.deviceabsolutewidth = window.screen.width;
  attrs.devicePixelRatio = window.devicePixelRatio;
  attrs.pagewidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  attrs.pageheight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
  attrs.domainname = store.getters.currentDomainName;
  attrs.timezone = moment.tz.guess(true);
  attrs.utcoffsetmins = moment().utcOffset();
  //console.log(`Name of currentDomain = ${store.getters.currentDomainName}`);
  return attrs;
  
}

//export default { AnalyticsEvents }


function getDevice() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
  // Check if the user agent indicates a mobile device
  if (/android/i.test(userAgent)) {
    return "Mobile";
  }
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "Tablet";
  }
  if (/Mobile|Android|iP(hone|od|ad)|Opera Mini|IEMobile|WPDesktop/.test(userAgent)) {
    return "Mobile";
  }
  
  return "Desktop"; 
}

function getBrowserName() {
  const userAgent = navigator.userAgent;

  if (navigator.brave) {
    return "Brave";
  }

  if (userAgent.indexOf("Chrome") > -1 && userAgent.indexOf("Edg") === -1) {
    return "Chrome";
  } else if (userAgent.indexOf("Safari") > -1 && userAgent.indexOf("Chrome") === -1) {
    return "Safari";
  } else if (userAgent.indexOf("Firefox") > -1) {
    return "Firefox";
  } else if (userAgent.indexOf("Edg") > -1) {
    return "Edge";
  } else if (userAgent.indexOf("Opera") > -1 || userAgent.indexOf("OPR") > -1) {
    return "Opera";
  } else if (userAgent.indexOf("MSIE") > -1 || !!document.documentMode) {
    return "Internet Explorer";
  } else {
    return "Unknown";
  }
}